import { useEffect, useState } from 'react';

export function useSearchKeyHandlers(items) {
  const [keyboardLocation, setKeyboardLocation] = useState(0);

  const keyMap = {
    MOVE_UP: ['ArrowUp', 'up'],
    MOVE_DOWN: ['ArrowDown', 'down'],
    NAVIGATE_TO: 'NAVIGATE_TO',
  };

  const keyHandlers = {
    MOVE_UP: () => move(keyboardLocation - 1),
    MOVE_DOWN: () => move(keyboardLocation + 1),
    NAVIGATE_TO: () => enter(),
  };

  useEffect(() => {
    // focusing the first element
    if (items && items.length > 0) {
      const timeoutId = setTimeout(() => {
        move(0);
      }, 0);

      return () => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  const move = (index) => {
    // unfocusing the old element
    const oldElement = document.getElementById(
      items[keyboardLocation].id.toString()
    );
    if (index >= 0 && index < items.length) {
      if (oldElement) {
        oldElement.style.backgroundColor = 'transparent';
      }

      // focusing & scrolling to the new element
      const newElement = document.getElementById(items[index].id.toString());
      if (newElement) {
        newElement.scrollIntoView({ block: 'nearest' });
        newElement.style.backgroundColor = 'var(--ui02)';
      }

      //saveing the new location
      setKeyboardLocation(index);
    }
  };

  const enter = () => {
    const element = document.getElementById(
      items[keyboardLocation]?.id.toString()
    );
    element?.click();
  };

  return {
    setKeyboardLocation,
    keyMap,
    keyHandlers,
  };
}
